import React from 'react'
import { Icon } from '../../../../../atoms/Icon'
import { InfoTooltip } from '../../../../../InfoTooltip'
import { TooltipMetricExplanation } from '../../../../../TooltipMetricExplanation'
import {
  Card,
  CardHeader,
  CardTitle,
  MetricGrid,
  MetricRow,
  MetricLabel,
  MetricValue,
} from '../../../BuildingCharacteristics.styles'
import type { NeighborhoodStatsCardProps } from '../NeighborhoodContextTab.types'

export const NeighborhoodStatsCard: React.FC<NeighborhoodStatsCardProps> = ({
  building,
  neighborsCount,
  t,
}) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>
          <Icon name="map" size="small" />
          {t('neighborhood.title')}
        </CardTitle>
      </CardHeader>
      <MetricGrid>
        <MetricRow>
          <MetricLabel>
            {t('neighborhood.metrics.neighboringBuildings.label')}
            <InfoTooltip>
              <TooltipMetricExplanation
                title={t(
                  'neighborhood.metrics.neighboringBuildings.tooltip.title'
                )}
                shortDescription={t(
                  'neighborhood.metrics.neighboringBuildings.tooltip.description'
                )}
                calculation={t(
                  'neighborhood.metrics.neighboringBuildings.tooltip.calculation'
                )}
                importance={t(
                  'neighborhood.metrics.neighboringBuildings.tooltip.importance'
                )}
                source={t(
                  'neighborhood.metrics.neighboringBuildings.tooltip.source'
                )}
              />
            </InfoTooltip>
          </MetricLabel>
          <MetricValue>
            {neighborsCount || t('common.notAvailable')}
          </MetricValue>
        </MetricRow>
        {building.building_density && (
          <MetricRow>
            <MetricLabel>
              {t('neighborhood.metrics.buildingDensity.label')}
              <InfoTooltip>
                <TooltipMetricExplanation
                  title={t(
                    'neighborhood.metrics.buildingDensity.tooltip.title'
                  )}
                  shortDescription={t(
                    'neighborhood.metrics.buildingDensity.tooltip.description'
                  )}
                  calculation={t(
                    'neighborhood.metrics.buildingDensity.tooltip.calculation'
                  )}
                  importance={t(
                    'neighborhood.metrics.buildingDensity.tooltip.importance'
                  )}
                  source={t(
                    'neighborhood.metrics.buildingDensity.tooltip.source'
                  )}
                />
              </InfoTooltip>
            </MetricLabel>
            <MetricValue>
              {t('neighborhood.metrics.buildingDensity.value', {
                density: building.building_density.toFixed(2),
              })}
            </MetricValue>
          </MetricRow>
        )}
        {building.neighbors_building_year_mean && (
          <MetricRow>
            <MetricLabel>
              {t('neighborhood.metrics.avgNeighborAge.label')}
              <InfoTooltip>
                <TooltipMetricExplanation
                  title={t('neighborhood.metrics.avgNeighborAge.tooltip.title')}
                  shortDescription={t(
                    'neighborhood.metrics.avgNeighborAge.tooltip.description'
                  )}
                  calculation={t(
                    'neighborhood.metrics.avgNeighborAge.tooltip.calculation'
                  )}
                  importance={t(
                    'neighborhood.metrics.avgNeighborAge.tooltip.importance'
                  )}
                  source={t(
                    'neighborhood.metrics.avgNeighborAge.tooltip.source'
                  )}
                />
              </InfoTooltip>
            </MetricLabel>
            <MetricValue>
              {t('neighborhood.metrics.avgNeighborAge.value', {
                years:
                  new Date().getFullYear() -
                  Math.round(building.neighbors_building_year_mean),
              })}
            </MetricValue>
          </MetricRow>
        )}
      </MetricGrid>
    </Card>
  )
}
